import { AnyAction } from 'redux';
import { AngebotsId, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { GesamtpreisInfo } from '../interfaces/gesamtpreisInfo';
import { ToolbarActions } from '../toolbar.actions';
import { IAppState } from '../toolbarState';

export const gesamtpreisPopoverReducer = function (
  sectionState: GesamtpreisInfo = null,
  action: AnyAction,
  state: IAppState,
): GesamtpreisInfo {
  switch (action.type) {
    case ToolbarActions.GESAMTPREIS_POPOVER_OPEN_CHANGED: {
      return {
        ...sectionState,
        gesamtpreisInfoChanged: action.payload,
      };
    }
    case GlobalActions.PRODUKT_DELETED: {
      return { ...sectionState, vereinbarungenInfoChanged: false };
    }
    case GlobalActions.TREUEBONUS_MAX_RECEIVED:
    case GlobalActions.VERTRAGSLAUFZEIT_CHANGED: {
      const actionPayload: AngebotsId = action.payload;
      const { appId, angebotsId } = actionPayload;
      const treuebonusToChange = state.treuebonus.find(
        value => value.appId === appId && value.angebotsId === angebotsId,
      );
      if (treuebonusToChange && treuebonusToChange.treuebonus_aktuell !== 0) {
        return {
          ...sectionState,
          vereinbarungenInfoChanged: true,
        };
      }
      return sectionState;
    }
    case GlobalActions.RABATT_HINWEIS_CHANGED: {
      if (action.payload !== sectionState.vereinbarungenInfoChanged) {
        return {
          ...sectionState,
          vereinbarungenInfoChanged: action.payload,
        };
      }
      return sectionState;
    }
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA: {
      const rdbWillChange = state.rbd?.reduce((pre, curr) => pre || curr.rbd_aktuell > 0, false);
      const tbWillChange = state.treuebonus?.reduce(
        (pre, curr) => pre || curr.treuebonus_aktuell > 0,
        false,
      );

      return {
        ...sectionState,
        vereinbarungenInfoChanged: rdbWillChange || tbWillChange,
      };
    }
    default:
      return sectionState;
  }
};
